import { render, staticRenderFns } from "./MobileNav.vue?vue&type=template&id=535566b4&scoped=true&"
import script from "./MobileNav.vue?vue&type=script&lang=js&"
export * from "./MobileNav.vue?vue&type=script&lang=js&"
import style0 from "./MobileNav.vue?vue&type=style&index=0&id=535566b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535566b4",
  null
  
)

export default component.exports